module.exports = __webpack_public_path__ + "static/media/BackToLobby.b17c931f.png";